import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { brand } from '../mock';

export default function FloatingActions() {
  const waLink = `https://wa.me/${brand.whatsapp}?text=${encodeURIComponent(brand.whatsappMessage)}`;
  return (
    <>
      <a
        href={waLink}
        target="_blank"
        rel="noreferrer"
        className="floating-btn"
        style={{ bottom: 90, background: '#25D366' }}
        aria-label="WhatsApp"
        title="Chat on WhatsApp"
      >
        <MessageCircle size={26} />
      </a>
      <a
        href={`tel:${brand.phoneRaw}`}
        className="floating-btn"
        style={{ bottom: 20, background: 'var(--brand-green)' }}
        aria-label="Call"
        title="Call us"
      >
        <Phone size={22} />
      </a>
    </>
  );
}
